const FIREBASE_ERROR_MAPPER: Record<string, string> = {
  'auth/email-already-in-use': 'The User with this email is already exist',
  'auth/wrong-password': 'You entered wrong password',
  'auth/user-not-found': 'The User does not exist',
};

export const getMessageFromCode = (code: string) => {
  return FIREBASE_ERROR_MAPPER[code] || 'Ups something went wrong';
};
